import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppStepCounterPage } from './app-step-counter';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppStepCounterPage,
  ],
  imports: [
    IonicPageModule.forChild(AppStepCounterPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppStepCounterPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-step-counter/app-step-counter.module.ts